import { createAction, createSlice } from "@reduxjs/toolkit";

import type { RootState } from "../../../store";
import type { ObjectWithId } from "../../../utils/ObjectWithId";
import type { PaymentsQueryParams } from "../models/Payment";
import type { Report } from "../models/Reports";

const initialState: {
  reports: Report[];
  link: string | null;
  polling: boolean;
  downloadedReportsIds: string[];
} = { reports: [], link: null, polling: true, downloadedReportsIds: [] };

export const slice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setReports: (state, action) => {
      state.reports = action.payload;
    },
    setReportLink: (state, action) => {
      state.link = action.payload;
    },
    startPolling: (state) => {
      state.polling = true;
    },
    cancelPolling: (state) => {
      state.polling = false;
    },
    setDownloadedReportsIds: (state, action) => {
      state.downloadedReportsIds = [
        ...new Set([...state.downloadedReportsIds, action.payload]),
      ];
    },
    removeReport: (state, action) => {
      state.reports = state.reports.filter(
        (report) => report.id !== action.payload
      );
    },
  },
});

export const reportsOperationPaths = () => {
  return {
    generate: ["reports", "generate"],
    fetch: ["reports", "fetch"],
    download: ["reports", "download"],
    delete: ["reports", "delete"],
  };
};

export const {
  setReports,
  setReportLink,
  startPolling,
  cancelPolling,
  setDownloadedReportsIds,
  removeReport,
} = slice.actions;

export const generateReport = createAction<{
  filters: Omit<PaymentsQueryParams, "page" | "limit">;
}>("generateReport");
export const fetchReports = createAction("fetchReports");

export const downloadReport = createAction<ObjectWithId>("downloadReport");

export const deleteReport = createAction<ObjectWithId>("deleteReport");

export const selectReports = (state: RootState) => state.reports.reports;

export const selectReportLink = (state: RootState) => state.reports.link;

export const selectDownloadedReportsIds = (state: RootState) =>
  state.reports.downloadedReportsIds;

export default slice.reducer;
